import { Link } from "@tanstack/react-router";
import { Bitcoin } from "lucide-react";

export function Brand({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  const text = size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-xl";
  const icon = size === "lg" ? "h-7 w-7" : size === "sm" ? "h-4 w-4" : "h-5 w-5";
  return (
    <Link to="/" className="flex items-center gap-2 group">
      <span className="grid place-items-center rounded-md bg-gradient-to-br from-primary to-amber-400 p-1.5 text-primary-foreground shadow-lg shadow-primary/20 group-hover:scale-105 transition-transform">
        <Bitcoin className={icon} />
      </span>
      <span className={`${text} font-semibold tracking-tight`}>
        CryptoBull <span className="text-gradient-gold">Pro</span>
      </span>
    </Link>
  );
}